// The routes a guest lands on: the bottom navbar tabs and the login view.
const primaryRouteNames = [
  'HomeRoutes',
  'SiteUnitRoutes',
  'WalletRoutes',
  'BenefitsRoutes',
  'NewsRoutes',
  'LoginView',
] as const;

interface Preloadable {
  preload(): Promise<void>;
}

const isPreloadable = (route: unknown): route is Preloadable =>
  typeof (route as Preloadable | undefined)?.preload === 'function';

/**
 * Loads the primary routes in the background so they can render without the
 * full-screen loading fallback. The native build bundles its routes eagerly,
 * those have nothing to preload.
 */
export const preloadPrimaryRoutes = (
  routes: Readonly<Record<string, unknown>>,
) => {
  for (const name of primaryRouteNames) {
    const route = routes[name];

    if (isPreloadable(route)) {
      void route.preload();
    }
  }
};
